import React from 'react'
import {
    Button,
    Input,
} from 'reactstrap'
import {
    IoIosArrowUp,
    IoIosArrowDown,
} from 'react-icons/io';

class MultipleValuesInColumnArrowsView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'index': props.length > 1 ? props.length-2 : props.length-1,
        }
    }

    updateIndex(newIndex) {
        if (newIndex < 0) {
            newIndex = 0
        }
        if (newIndex >= this.props.length) {
            newIndex = this.props.length-1
        }

        this.setState({
            'index': newIndex,
        })
    }

    render() {
        return <div
                style={{
                    'display': 'flex',
                }}
            >
            <div
                style={{
                    'display': 'grid',
                     'marginRight': '4px',
                }}
            >
                <Button
                    style={{
                        'height': '10pt',
                        'margin': '0pt',
                        'padding': '0pt',
                        'marginTop': '3pt',
                    }}
                    size='sm'
                    onClick={(e) => {
                        this.updateIndex(this.state.index-1)
                    }}>
                    <IoIosArrowUp
                        style={{
                            'margin-top': '-10pt',
                            'margin': '0pt',
                            'padding': '0pt',
                            'fontSize': '10pt',
                            'fontWeight': 'bold',
                            'marginTop': '-10pt',
                        }}/>
                </Button>
                <Button
                    style={{
                        'height': '10pt',
                        'margin': '0pt',
                        'padding': '0pt',
                        'marginTop': '3pt',
                    }}
                    size='sm'
                    onClick={(e) => {
                        this.updateIndex(this.state.index+1)
                    }}>
                    <IoIosArrowDown
                        style={{
                            'margin': '0pt',
                            'padding': '0pt',
                            'fontSize': '10pt',
                            'fontWeight': 'bold',
                            'marginTop': '-10pt',
                        }}/>
                </Button>
            </div>
            <div
                style={{
                    'display': 'grid',
                }}
            >
                {this.props.view(this.state.index)}
            </div>
        </div>
    }
}

const MultipleStringsInColumnArrowsView = (props) => {
    return <MultipleValuesInColumnArrowsView
        length={props.values.length+1}
        view={(index) => {
            return <Input
                type='text'
                value={
                    index >= props.values.length
                    ? ''
                    : props.values[index]
                }
                onChange={(e) => {
                    let values = [...props.values]
                    if (index >= values.length) {
                        values.push(e.target.value)
                    } else {
                        values[index] = e.target.value
                    }

                    while (values[values.length-1] === '') {
                        values = values.slice(0, values.length-1)
                    }

                    props.onChange(values)
                }}
            />
        }}
    />
}

export {
    MultipleValuesInColumnArrowsView,
    MultipleStringsInColumnArrowsView,
}
